export const colors = {
  primary: '#3495fd',
  danger: '#dc4453',
  success: '#5fba7d',
  tertiary: '#13d15e',
  warning: '#f0bf57',
};
